import client from "./axiosConfig";

export const getBillSummaryData = (params) => {
  const config = {
    url: "bill_manager/bill-summary/",
    method: "GET",
    params
  };
  return client(config);
};
export const getAttendanceSummaryData = (params) => {
  const config = {
    url: "/attendance/type_wise_total/",
    method: "GET",
    params
  };
  return client(config);
};
export const getDailyTaskSummaryData = (params) => {
  const config = {
    url: "/attendance/day_wise_attendance",
    method: "GET",
    params
  };
  return client(config);
};

export const getTotalSummaryData = (params) => {
  const config = {
    url: "bill_manager/bill-summary/status_wise_total/",
    method: "GET",
    params
  };
  return client(config);
};
export const getTaskSummaryData = (params) => {
  const config = {
    url: "/task_manager/task/status_wise_task",
    method: "GET",
    params
  };
  return client(config);
};